import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_STATE, SUMMARY_BY_STATE } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByStatePage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByStateQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By State" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By State</h1>
      <OrdersCategoryList
        categoryTitle="si_state"
        columns={SUMMARY_BY_STATE}
        unit="state(s)"
        resizeStorageKey="orders-by-state"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders shipped to ${row.category}`}
            columns={DRILLDOWN_BY_STATE}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            state={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByStatePage;
